<template>
  <div class="popup-backdrop" v-bind:class="{ hide : dynamicComponent === ''}">
    <component v-bind:is="dynamicComponent"></component>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

const UserNewPopup = () => import('@/components/popups/userNewPopup.vue');
const UserGroupNewPopup = () => import('@/components/popups/userGroupNewPopup.vue');
const UserNewInGroupPopup = () => import('@/components/popups/userNewInGroupPopup.vue');
const UploadFilePopup = () => import('@/components/popups/uploadFilePopup.vue');
const EventsEditPopup = () => import('@/components/popups/eventsEditPopup.vue');
const DeletePopup = () => import('@/components/popups/deletePopup.vue');
const AddImage = () => import('@/components/popups/addImagePopup.vue');
const EditCategory = () => import('@/components/popups/editCategoryNamePopup.vue');
const EditShop = () => import('@/components/popups/editShopPopup.vue');
const ShopCategories = () => import('@/components/popups/addCategoriesPopup.vue');
const EditService = () => import('@/components/popups/addNewServicePopup.vue');
const EditOffer = () => import('@/components/popups/offerEditPopup.vue');
const EditMall = () => import('@/components/popups/AddMallPopup.vue');
const MallUsers = () => import('@/components/popups/AddUsersPopup.vue');
const TextEditor = () => import('@/components/popups/editTextPopup.vue');
const PreviewSlideShow = () => import('@/components/popups/previewSlidePopup.vue');
const EditSlideShow = () => import('@/components/popups/editSlidePopup.vue');
const CopyPopup = () => import('@/components/popups/copyPopup.vue');
const StationPopup = () => import('@/components/popups/AddStationPopup.vue');
const ChartView = () => import('@/components/popups/chartViewPopup.vue');
const EditGarage = () => import('@/components/popups/addNewGaragePopup.vue');
const EditFloor = () => import('@/components/popups/addFloorPopup.vue');
const PreviewImageShow = () => import('@/components/popups/previewImagesPopup.vue');
const addMediaCategory = () => import('../popups/addMediaCategoryPopup.vue');
const SmsNewPopup = () => import('@/components/popups/addEditSmsPopup.vue');

export default Vue.extend({
  name: 'popup',
  components: {
    'user-new-popup': UserNewPopup,
    'edit-garage': EditGarage,
    'edit-floor': EditFloor,
    'chart-view': ChartView,
    'station-popup': StationPopup,
    'copy-popup': CopyPopup,
    'text-editor': TextEditor,
    'edit-slide-show': EditSlideShow,
    'preview-slide-show': PreviewSlideShow,
    'preview-image-show': PreviewImageShow,
    'mall-new-popup': EditMall,
    'mall-users-popup': MallUsers,
    'edit-category': EditCategory,
    'offers-edit-popup': EditOffer,
    'edit-service': EditService,
    'shop-categories-popup': ShopCategories,
    'edit-shop': EditShop,
    'add-image-popup': AddImage,
    'events-edit-popup': EventsEditPopup,
    'delete-popup': DeletePopup,
    'user-group-new-popup': UserGroupNewPopup,
    'newuser-ingroup-popup': UserNewInGroupPopup,
    'upload-file-popup': UploadFilePopup,
    'media-category-new': addMediaCategory,
    'sms-new-popup': SmsNewPopup,
  },
  computed: {
    dynamicComponent(): string {
      return this.$store.state.popupViewName;
    }
  }
});
</script>
